// extracted by css-extract-rspack-plugin
export default {"externalPersonDetail":"externalPersonDetail-UtIPbH","titleNav":"titleNav-vV3bp7","flex_space_between":"flex_space_between-iTqFgx","flexSpaceBetween":"flex_space_between-iTqFgx"};